import { z, ZodSchema } from 'zod';
import { EmailSchema } from '../shared/utility/email.schema';
import { UpdateUserRequest } from '@/types/api/user';
import { MobileNumberSchema } from '../shared/utility/mobile-number.schema';
import { NameSchema } from '../shared/utility/name.schema';

export const UpdateUserSchema: ZodSchema<UpdateUserRequest> = z.object({
  firstName: NameSchema,
  lastName: NameSchema,
  email: EmailSchema,
  mobileNumber: MobileNumberSchema,
});
